export default __webpack_public_path__ + "img/BF.c2e57606f2bcba322b72d7576e12fe22.jpg";